module.exports = __webpack_public_path__ + "media/images/cards/cc-diners-club-1f9f04904b2c669569e6c989de296a9d.svg";